'use strict';

/**
 * Converts a string to a slug by removing special characters and replacing spaces with hyphens.
 * @param str - The string to be slugified.
 * @returns The slugified string.
 */ function slugify(str = '') {
    return str.toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-|-$/, '');
}

module.exports = slugify;
